import { Box, Popover, type PopoverProps, type SxProps } from '@mui/material'
import { globalCssVars } from '@/core/theme/GlobalCssVars.ts'

export interface DefaultPopoverProps {
  anchorEl: Element | undefined
  close: () => void
  children: React.ReactNode
  slots?: {
    popover?: Partial<PopoverProps>
  }
  slotSx?: {
    paper?: SxProps
  }
}

export function DefaultPopover({ anchorEl, close, slots, slotSx, children }: DefaultPopoverProps) {
  if (!anchorEl) return null

  return (
    <Box
      onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      <Popover
        open
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        {...(slots?.popover ?? {})}
        slotProps={{
          paper: {
            className: 'optionsPopoverPaper',
            sx: [
              (theme) => ({
                background: theme.palette.background.paper,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: globalCssVars.radius5,
              }),
              ...(Array.isArray(slotSx?.paper)
                ? slotSx.paper
                : slotSx?.paper
                  ? [slotSx.paper]
                  : []),
            ],
          },
        }}
      >
        {children}
      </Popover>
    </Box>
  )
}
